export default {
	type: 'object',
	properties: {
		campaignId: { type: 'string' },
	},
	required: ['campaignId'],
	additionalProperties: false,
}
